/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";
import {
  ErrorStateComponent,
  ErrorStateIconType,
  IErrorStateComponentProps,
} from "@cseo/controls";
import { ErrorHeaderStyle } from "./history-error.styles";
import { triggerReferenceHistory } from "./reference-middle-layer";
import { TelemetryHistoryLogs } from "../constants";
interface candidateProps {
  setIsRefreshTrue: () => void;
}
export const HistoryErrorBody: React.FC<candidateProps> = ({
  setIsRefreshTrue,
}) => {
  const payload: IErrorStateComponentProps = {
    headingText: "Something went wrong!",
    descriptionText:
      "We are unable to load the reference history currently. Please try refreshing the reference history.",
    iconType: ErrorStateIconType.InternetIssue,
    styles: ErrorHeaderStyle,
    callToActionButton: {
      ctaText: "Refresh",
      ctaHandler: setIsRefreshTrue,
      ctaAriaLabel: "Refresh reference history",
    },
  };
  triggerReferenceHistory(TelemetryHistoryLogs.ReferenceHistoryError);
  return <ErrorStateComponent {...payload} />;
};
